import { Check, Info, TriangleAlert, X } from "lucide-react";
import type { ReactNode } from "react";

export function StatusDot({ status }: { status: string }) {
  return <span className={`status-dot status-${status}`} aria-hidden="true" />;
}

export function EmptyState({ icon, title, detail, action }: { icon: ReactNode; title: string; detail?: string; action?: ReactNode }) {
  return (
    <div className="empty-state">
      <div className="empty-icon">{icon}</div>
      <strong>{title}</strong>
      {detail && <span>{detail}</span>}
      {action}
    </div>
  );
}

export function Toast({ message, tone, onClose }: { message: string; tone: "success" | "error" | "info"; onClose: () => void }) {
  const Icon = tone === "success" ? Check : tone === "error" ? TriangleAlert : Info;
  return (
    <div className={`toast toast-${tone}`} role={tone === "error" ? "alert" : "status"}>
      <Icon size={12} />
      <span>{message}</span>
      <button type="button" onClick={onClose} title="关闭通知" aria-label="关闭通知"><X size={15} /></button>
    </div>
  );
}

export function ScoreBadge({ value }: { value: number | null }) {
  if (value === null || !Number.isFinite(value)) return <span className="score-badge score-empty">--</span>;
  const tone = value >= 8.5 ? "good" : value >= 7.5 ? "mid" : "low";
  return <span className={`score-badge score-${tone}`}>{value.toFixed(1)}</span>;
}

export function formatNumber(value: number): string {
  return new Intl.NumberFormat("zh-CN").format(value);
}

export function relativeTime(value: string): string {
  const diff = Date.now() - new Date(value).getTime();
  if (!Number.isFinite(diff)) return "未知时间";
  if (diff < 60_000) return "刚刚";
  if (diff < 3_600_000) return `${Math.floor(diff / 60_000)} 分钟前`;
  if (diff < 86_400_000) return `${Math.floor(diff / 3_600_000)} 小时前`;
  return new Date(value).toLocaleDateString("zh-CN", { month: "short", day: "numeric" });
}
